interface IBackKeyPress
{
    actionName: string,
    handler: any,
    keypressHandler: any;
}
let topBackKeyPressArray : Array<IBackKeyPress>=[];

export const commonKeyCode  = {
    "Enter": 13,
    "Left": 37,
    "Up": 38,
    "Right": 39,
    "Down": 40,
    "Play": 415,
    "Pause": 19,
    "Rewind": 412,
    "FastForward": 417,
    "Stop": 413,
}

export const webOsKeyCode = {
    "Back": 461,
}

export const tizenKeyCode = {
    "Back": 10009,
    "PlayPause": 10252
}


export const activeOverlayBackkeyPressAction = (name: string, actionHandler: any) => {
    const backKeypressHandler = (event:any) =>{
       isBackKey(event, name)? actionHandler() : '';
    }

   topBackKeyPressArray.push({actionName: name, handler: actionHandler, keypressHandler :backKeypressHandler });
   window.addEventListener('keydown', topBackKeyPressArray[topBackKeyPressArray.length - 1].keypressHandler)
}

export const clearActiveOverlayBackkeyPressAction = (name:any, actionHandler: any) => {

    window.removeEventListener('keydown', topBackKeyPressArray[topBackKeyPressArray.length - 1].keypressHandler)
    topBackKeyPressArray.pop();
}

export const isBackKey = (event: any, name: any='') => {
    const topActionStatus = (topBackKeyPressArray.length > 0?  topBackKeyPressArray[topBackKeyPressArray.length -1].actionName === name : true); 
    // keep below line commented, only for local development
    if( topActionStatus && event?.key === "Escape") return true

    if(topActionStatus && (event?.keyCode == 461 || event?.keyCode == 10009) && !document.getElementById("toast-screen")) {
        return true
    }

    return false
}

export const isNumericKey = (event: any) => {
    return ["0","1","2","3","4","5","6","7","8","9"].includes(event.key) && document?.activeElement?.tagName !== "INPUT";
}

export const isChannelUpKeyPressed = (event: any) => {
    const KeyChannelUpTizen = 427;
    const KeyChannelUpWebOs = 33;
    if(event?.keyCode == KeyChannelUpTizen || event?.keyCode == KeyChannelUpWebOs) {
        return true
    }

    return false
}
export const isChannelDownKeyPressed = (event: any) => {
    const KeyChannelDownTizen = 428;
    const KeyChannelDownWebOs = 34;
    if(event?.keyCode == KeyChannelDownTizen || event?.keyCode == KeyChannelDownWebOs) {
        return true
    }

    return false
}
